import React, { Component } from "react";
import PropTypes from "prop-types";
import { fetchData, search } from "../../../../_actions/sidebarSliderActions";
import { connect } from "react-redux";
import {
  ShowCenterSpinner,
  ShowNoContent,
} from "../../../common/statelessView";
import TemplateCategorySlider from "./TemplateCategorySlider";
import { isEmpty } from "lodash";
import TLDRInfiniteScroll from "../../../common/TLDRInfiniteScroll";
import SearchForm from "../../../common/SearchForm";
import { TEMPLATES_SLIDER_PANEL } from "../../constants";
import { withTranslation } from "react-i18next";
import { Divider } from "@chakra-ui/react";

class TemplateCategories extends Component {
  render() {
    const { sidebarSlider, artBoardHandler, t } = this.props;
    const { payload, loaded, hasMore } = sidebarSlider;
    let className =
      this.props.panelType === TEMPLATES_SLIDER_PANEL
        ? "template-item"
        : "item item-element element-slider-item";
    let itemWidth =
      this.props.panelType === TEMPLATES_SLIDER_PANEL ? 100 : 80.656;
    let spaceBetween = this.props.panelType === TEMPLATES_SLIDER_PANEL ? 6 : 15;
    let elementTypeSliders = [];
    elementTypeSliders = payload.map((item) => {
      let categoryType = item.category?.display_name;
      let categoryTitle = item?.category?.display_name;
      let categoryId = item.category?.id;

      return (
        <TemplateCategorySlider
          className={className}
          categoryType={categoryType}
          title={categoryTitle}
          itemWidth={itemWidth}
          spaceBetween={spaceBetween}
          data={this.preparePayload(item)}
          key={categoryId}
          categoryId={categoryId}
          artBoardHandler={artBoardHandler}
        />
      );
    });

    const searchPlaceholder =
      this.props.panelType === TEMPLATES_SLIDER_PANEL
        ? t("featured_templates.search_all")
        : t("featured_templates.search_graphics");

    const noResultFound =
      this.props.panelType === TEMPLATES_SLIDER_PANEL
        ? t("errors.not_found")
        : t("errors.not_found");

    return (
      <>
        <SearchForm searchPlaceholder={searchPlaceholder} />
        <Divider orientation="horizontal" className="tldr-hr" opacity={0.2} w={`calc(100% - 24px)`} ml={1} mr={0} mb={4}/>
        {!loaded ? (
          <ShowCenterSpinner loaded={loaded}></ShowCenterSpinner>
        ) : elementTypeSliders.length === 0 ? (
          <ShowNoContent text={noResultFound} />
        ) : (
          <div
            id="template-gallery-scrollable-wrapper"
            className={"tab-template-gallery"}
          >
            <TLDRInfiniteScroll
              childrens={elementTypeSliders}
              className="infinite_scroll"
              hasMore={hasMore}
              loadMoreData={this.loadPage}
              scrollableTarget="template-gallery-scrollable-wrapper"
              loaded={loaded}
            />
          </div>
        )}
      </>
    );
  }

  componentDidMount() {
    this.loadPage(1);
  }

  loadPage = (groupKey) => {
    // There is no searchText then fetch general images and add into InfiniteGrid
    if (!this.props.searchText) {
      this.props.fetchData("", { ...this.props, groupKey });
    } else {
      this.props.search("", this.props.searchText, { ...this.props, groupKey });
    }
  };

  preparePayload = (data) => {
    if (isEmpty(data.payload)) {
      data.payload = {};
    }
    data.payload["source"] = "TLDR";
    data.payload["type"] = "svg";
    return data.payload;
  };
}

TemplateCategories.propTypes = {
  panelType: PropTypes.string.isRequired,
  editor: PropTypes.object.isRequired,
  fetchData: PropTypes.func.isRequired,
};

TemplateCategories.defaultProps = {};

const mapStateToProps = (state) => ({
  contentSize: state.story.contentSize,
  panelType: state.sidebarSlider.sliderPanelType,
  sidebarSlider: state.sidebarSlider,
  editor: state.editor,
  page: state.sidebarSlider.page,
  searchText: state.sidebarSlider.searchText,
});

const mapDispatchToProps = (dispatch) => ({
  fetchData: (source, props) => dispatch(fetchData(source, props)),
  search: (source, searchTerm, props) =>
    dispatch(search(source, searchTerm, props)),
});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(TemplateCategories)
);
